export default __webpack_public_path__ + "68bd182.png";